import { render, staticRenderFns } from "./ChallengesList.vue?vue&type=template&id=b8c5e7c4&"
import script from "./ChallengesList.vue?vue&type=script&lang=js&"
export * from "./ChallengesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports